import { de_GetSimulationResultsCommand, se_GetSimulationResultsCommand, } from "../protocols/Aws_restJson1";
import { getSerdePlugin } from "@smithy/middleware-serde";
import { Command as $Command } from "@smithy/smithy-client";
export { $Command };
export class GetSimulationResultsCommand extends $Command.classBuilder()
    .m(function (Command, cs, config, o) {
    return [
        getSerdePlugin(config, this.serialize, this.deserialize),
    ];
})
    .s("SimulationService", "GetSimulationResults", {})
    .n("SimulationServiceClient", "GetSimulationResultsCommand")
    .f(void 0, void 0)
    .ser(se_GetSimulationResultsCommand)
    .de(de_GetSimulationResultsCommand)
    .build() {
}
